import { useSearchParams } from 'react-router-dom';
import { Button } from '../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { useLang } from '../../../../../../hooks/use-lang';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import s from './archive-branch-modal.module.css';

export const ArchiveBranchModal = (props: ModalProps) => {
  const { archiveBranch, isLoading } = useBranchesStore();
  const [params] = useSearchParams();
  const { t } = useLang();
  const id = params.get('branchId');
  const name = params.get('branchName');

  const handleArchive = async () => {
    if (id) {
      await archiveBranch(id).then(props.onClose);
    }
  };

  return (
    <Modal {...props} title={t('Архивировать филиал')} className={s.feature}>
      <label>
        {t('Вы действительно хотите архивировать филиал {{placeName}}?', { placeName: name })}
      </label>
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose} disabled={isLoading}>
          {t('Отменить')}
        </Button>
        <Button onClick={handleArchive} disabled={isLoading} variant="danger">
          {t('Архивировать')}
        </Button>
      </div>
    </Modal>
  );
};
